"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BankTransferFilterBody = BankTransferFilterBody;
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const FormContext_1 = require("../../View/Modals/FormContext");
const GenericComponents_1 = require("../../View/Modals/CommonFormComponents/GenericComponents");
function BankTransferFilterBody() {
    const { register } = (0, FormContext_1.useFormContext)();
    return (react_1.default.createElement(react_bootstrap_1.Row, { className: "g-3" },
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, sm: 12, md: 4 },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Szukana fraza"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "text", placeholder: "Kontrahent, opis, nr konta", ...register('searchText') })),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, sm: 6, md: 2 },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Status"),
            react_1.default.createElement(react_bootstrap_1.Form.Select, { ...register('matchingStatus') },
                react_1.default.createElement("option", { value: "" }, "Wszystkie"),
                react_1.default.createElement("option", { value: "UNMATCHED" }, "Nierozliczone"),
                react_1.default.createElement("option", { value: "PROPOSED" }, "Proponowane"),
                react_1.default.createElement("option", { value: "CONFIRMED" }, "Potwierdzone"),
                react_1.default.createElement("option", { value: "MANUAL" }, "R\u0119czne"))),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, sm: 6, md: 2 },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Kierunek"),
            react_1.default.createElement(react_bootstrap_1.Form.Select, { ...register('direction') },
                react_1.default.createElement("option", { value: "" }, "Oba"),
                react_1.default.createElement("option", { value: "IN" }, "IN (przychodz\u0105ce)"),
                react_1.default.createElement("option", { value: "OUT" }, "OUT (wychodz\u0105ce)"))),
        react_1.default.createElement(GenericComponents_1.DateRangeInput, { as: react_bootstrap_1.Col, sm: 12, md: 4, label: "Data realizacji", fromName: "dateFrom", toName: "dateTo", showValidationInfo: false })));
}
